export const config = [
  {
    id: 1,
    title: 'Docs',
    children: [
      {
        title: 'Online',
        url: '/docs/online/',
      },
      {
        title: 'In-Person',
        url: '/docs/in-person/',
      },
      {
        title: 'Multiparty',
        url: '/docs/multiparty/',
      },
      {
        title: '3rd-Party',
        url: '/docs/3rd-party/',
      },
      {
        title: 'Payouts',
        url: '/docs/payouts/',
      },
      {
        title: 'Disputes',
        url: '/docs/disputes/',
      },
      {
        title: 'Reports',
        url: '/docs/reports/',
      },
      {
        title: 'Identity',
        url: '/docs/log-in-with-paypal/',
      },
      {
        title: 'Docs Archive',
        url: '/docs/archive',
      },
    ],
  },
  {
    id: 2,
    title: 'APIs & SDKs',
    children: [
      {
        title: 'REST APIs',
        url: '/api/rest/',
      },
      {
        title: 'JavaScript SDK',
        url: '/sdk/js/',
      },
      {
        title: 'NVP/SOAP APIs',
        url: '/api/nvp-soap/',
      },
      {
        title: 'Donate SDK',
        url: '/sdk/donate/',
      },
      {
        title: 'Braintree GraphQL API',
        url: 'https://graphql.braintreepayments.com/',
      },
    ],
  },
  {
    id: 3,
    title: 'Tools',
    children: [
      {
        title: 'Integration Builder',
        url: '/integration-builder',
      },
      {
        title: 'Sandbox Testing Guide',
        url: '/tools/sandbox/',
      },
      {
        title: 'API Executor',
        url: 'https://www.paypal.com/apex/home',
      },
      {
        title: 'Demo Portal',
        url: 'https://demo.paypal.com/us/demo/home',
      },
      {
        title: 'Credit Card Generator',
        url: 'https://developer.paypal.com/developer/creditCardGenerator',
      },
      {
        title: 'Webhooks',
        url: '/api/rest/webhooks/',
      },
      {
        title: 'API Status',
        url: 'https://www.paypal-status.com/api/production',
      },
    ],
  },
  {
    id: 4,
    title: 'Support',
    link: '/docs/support/',
  },
]
